// Used to update which colour and sku is selected based on a partNumber regardless of whether it is colour or sku level
// Currently only needed as mini pdp doesn't specifiy what type of partNumber is being passed
// TODO: Update mini pdp size select and colour swatch select action to add partNumber type to payload. Then can use getSelectedProduct directly and remove this

/* Keep */
export const setSelectedWithinProduct = (product, payloadPartNumber) => {
    let selectedSkuPartNumber = null;
    const productColours = product.productColours.map((colour) => {
        let colourSelected = colour.partNumber === payloadPartNumber;

        !colourSelected &&
            colour.sKUs.forEach((sku) => {
                const { partNumber } = sku;
                if (partNumber === payloadPartNumber) {
                    colourSelected = true;
                    selectedSkuPartNumber = partNumber;
                }
            });

        return {
            ...colour,
            selected: colourSelected,
        };
    });
    return {
        ...product,
        productColours,
        // Passing this to getSelectedSize as second argument rather setting `selected` on sku level above
        selectedSku: { partNumber: selectedSkuPartNumber },
    };
};
